import { defaultFormItemLayout } from '../../../../../modules/FormItems'
import React from 'react'
import { Checkbox, Col, Form, Input, Row } from 'antd'
import { boolVal, strVal } from '../../../../../modules/Utils'
import { get } from 'lodash'
import ContractTypeSelect from '../../../../../elements/Select/Supplier/ContractType'
import OrganisationsSelect from '../../../../../elements/Select/Organistaions'
import CentersCascader from '../../../../../elements/Cascader/CentersCascader'
import withViewFormItem from 'form-item-view-hoc'

const { TextArea } = Input
const FormItem = withViewFormItem(Form.Item)

function Overview(props) {
  const formItemLayoutRow = {
    labelCol: {
      xs: { span: 24 },
      sm: { span: 7 },
    },
    wrapperCol: {
      xs: { span: 24 },
      sm: { span: 16 },
    },
  }
  const { getFieldDecorator, getFieldValue } = props.form
  const { contract, readOnly } = props

  const isLogistic = (getFieldValue('type') || strVal(contract, 'type')) === 'logistics'

  return (
    <Form layout="horizontal">
      <Row>
        <Col span={12}>
          <FormItem readOnly={readOnly} label="Title" {...formItemLayoutRow}>
            {getFieldDecorator('title', {
              initialValue: strVal(contract, 'title'),
              rules: [{ required: true, message: "Title can't be empty " }],
            })(<Input placeholder="Title" />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem
            readOnly={readOnly}
            display={strVal(contract, 'type').toUpperCase()}
            label="Account Type"
            {...formItemLayoutRow}>
            {getFieldDecorator('type', {
              initialValue: get(contract, 'type'),
              rules: [
                {
                  required: true,
                  message: "Contract Type can't be empty ",
                },
              ],
            })(<ContractTypeSelect />)}
          </FormItem>
        </Col>

        {isLogistic && (
          <Col span={12}>
            <Form.Item {...defaultFormItemLayout} label={'Default partner'}>
              {getFieldDecorator('default', {
                initialValue: get(contract, 'default') || false,
                valuePropName: 'checked',
              })(<Checkbox />)}
            </Form.Item>
          </Col>
        )}
      </Row>
      <Row>
        <Col span={12}>
          <FormItem readOnly={readOnly} display={strVal(contract, 'company.fn')} label="Company" {...formItemLayoutRow}>
            {getFieldDecorator('company._id', {
              initialValue: get(contract, 'company._id'),
              rules: [{ required: true, message: "Company can't be empty" }],
            })(<OrganisationsSelect placeholder={'Select a Company'} />)}
          </FormItem>
        </Col>
        <Col span={12}>
          <FormItem label="Blanket" {...formItemLayoutRow}>
            {getFieldDecorator('blanket', {
              initialValue: contract.blanket ? boolVal(contract, 'blanket') : true,
              valuePropName: 'checked',
            })(<Checkbox disabled={true} />)}
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <Form.Item label="Business Registration" {...formItemLayoutRow}>
            {getFieldDecorator('client.companyNo', {
              initialValue: strVal(contract, 'client.companyno'),
            })(<Input placeholder="Business Registration No" />)}
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item label="Tax Registration" {...formItemLayoutRow}>
            {getFieldDecorator('client.taxRegistration', {
              initialValue: strVal(contract, 'client.taxRegistration'),
            })(<Input placeholder="Tax Registration No" />)}
          </Form.Item>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <FormItem
            readOnly={readOnly}
            display={strVal(contract, 'center.name')}
            {...formItemLayoutRow}
            label={'Cost Center'}>
            {getFieldDecorator('budget.cost._id', {
              initialValue: get(contract, 'budget.cost._id'),
              rules: [
                {
                  type: 'array',
                  required: true,
                  message: "Cost can't be empty",
                },
              ],
            })(
              <CentersCascader
                style={{ width: '250%' }}
                key={getFieldValue('company._id')}
                category={'Cost'}
                company={getFieldValue('company._id')}
              />
            )}
          </FormItem>
        </Col>
      </Row>
      <Row>
        <Col span={12}>
          <FormItem readOnly={readOnly} label="Description" {...formItemLayoutRow}>
            {getFieldDecorator('description', {
              initialValue: get(contract, 'description'),
            })(<TextArea placeholder="Description" rows={4} />)}
          </FormItem>
        </Col>
      </Row>
    </Form>
  )
}

export default Form.create()(Overview)
